"use strict";
import { Grid, Input } from "@alifd/next";
import React from "react";
import { AiOutlineSearch } from "react-icons/ai";
import i18n from "../../../../i18n";
import "./index.less";
class SelectSearch extends React.Component {
  constructor() {
    super(...arguments);
    this.handleChangName = (e) => {
      this.props.handleChangName(e);
    };
  }
  render() {
    const { Row, Col } = Grid;
    const { searchValue } = this.props;
    return /* @__PURE__ */ React.createElement(Row, { className: "definitions-select-wrapper border-radius-8", wrap: true }, /* @__PURE__ */ React.createElement(Col, { m: 8, s: 12, xxs: 24, style: { padding: "0 8px" } }, /* @__PURE__ */ React.createElement(
      Input,
      {
        innerAfter: /* @__PURE__ */ React.createElement(AiOutlineSearch, { style: { margin: 4 } }),
        hasClear: true,
        size: "large",
        placeholder: i18n.t("Search by definition name"),
        onChange: this.handleChangName,
        value: searchValue,
        className: "item"
      }
    )));
  }
}
export default SelectSearch;
